import {useEffect, useState} from "react";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import CheckoutForm from "./app/common/stripe/CheckoutForm";
import {lookupClientSecret} from "./app/common/api/CartApi";

export default function StripeCheckoutPage({cart, handleSuccess, handleError, storeCard}) {

  const [clientSecret, setClientSecret] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    lookupClientSecret().then((result) => {
      setClientSecret(result['clientSecret']);
      setStripePromise(loadStripe(result['publishableKey']));
    });
  }, []);

  return (
    <div>
      {clientSecret &&
        <Elements
          options={{
            clientSecret: clientSecret
          }}
          stripe={stripePromise}>
          <CheckoutForm
            storeCard={storeCard}
            cart={cart}
            handleSuccess={handleSuccess}
            handleError={handleError}
            clientSecret={clientSecret}/>
        </Elements>
      }
    </div>
  );
}